import Icon from "../../../../src/components/icon";
import FaqAnswerUpgradeText from "../../../../src/components/faqAnswerUpgradeText";
import * as React from 'react';
export default {
  Icon,
  FaqAnswerUpgradeText,
  React
};